import { uniqueId } from 'lodash';
import React from 'react';

import { Select } from '@dndbeyond/character-components/es';
import { Ability, AbilityUtils, HelperUtils, HtmlSelectOption } from '@dndbeyond/character-rules-engine/es';

const totalPoints: number = 27;
const scoreChoices: Array<number> = [8, 9, 10, 11, 12, 13, 14, 15];
const scorePoints: Record<number, number> = {
    8: 0,
    9: 1,
    10: 2,
    11: 3,
    12: 4,
    13: 5,
    14: 7,
    15: 9,
};

function renderScoreLabel(score: number, currentScore: number | null): string {
    if (currentScore !== null) {
        if (score > currentScore) {
            const pointDiff = scorePoints[score] - scorePoints[currentScore];
            return `${score} (-${pointDiff} Point${pointDiff === 1 ? '' : 's'})`;
        } else if (score < currentScore) {
            const pointDiff = scorePoints[currentScore] - scorePoints[score];
            return `${score} (+${pointDiff} Point${pointDiff === 1 ? '' : 's'})`;
        }
    }

    return '' + score;
}

interface Props {
    abilities: Array<Ability>;
    onChange: (statId: number, value: number | null) => void;
}
export default class AbilityScoreManagerPointBuy extends React.PureComponent<Props> {
    handleChange = (statId: number, value: string): void => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(statId, HelperUtils.parseInputInt(value));
        }
    };

    render() {
        const { abilities } = this.props;

        const currentPoints = abilities.reduce(
            (acc: number, abilityScore) =>
                (acc += abilityScore.baseScore === null ? 0 : scorePoints[abilityScore.baseScore]),
            0,
        );
        const remainingPoints: number = totalPoints - currentPoints;

        return (
            <div className="ability-score-manager ability-score-manager-point">
                <div className="ability-score-manager-points">
                    <div className="ability-score-manager-points-heading">Points Remaining</div>
                    <div className="ability-score-manager-points-value">
                        <span className="ability-score-manager-points-value-remaining">{remainingPoints}</span>
                        <span className="ability-score-manager-points-value-sep">/</span>
                        <span className="ability-score-manager-points-value-total">{totalPoints}</span>
                    </div>
                </div>
                <div className="ability-score-manager-stats">
                    {abilities.map((abilityScore) => {
                        const uId = uniqueId('qry_');
                        const availableScores = scoreChoices.reduce((acc: Array<number>, score) => {
                            const pointDiff =
                                scorePoints[score] -
                                (abilityScore.baseScore === null ? 0 : scorePoints[abilityScore.baseScore]);

                            if (
                                pointDiff < 0 ||
                                (pointDiff > 0 && pointDiff <= remainingPoints) ||
                                score === abilityScore.baseScore
                            ) {
                                acc.push(score);
                            }

                            return acc;
                        }, []);
                        const availableScoreOptions: Array<HtmlSelectOption> = availableScores.map((score) => ({
                            label: renderScoreLabel(score, abilityScore.baseScore),
                            value: score,
                        }));

                        return (
                            <div className="ability-score-manager-stat" key={abilityScore.id}>
                                <div className="builder-field form-select-field">
                                    <span className="builder-field-label">
                                        <label className="builder-field-heading form-select-field-label" htmlFor={uId}>
                                            {abilityScore.label}
                                        </label>
                                    </span>
                                    <span className="builder-field-input">
                                        <Select
                                            id={uId}
                                            options={availableScoreOptions}
                                            value={abilityScore.baseScore}
                                            onChange={this.handleChange.bind(this, abilityScore.id)}
                                            initialOptionRemoved={true}
                                        />
                                    </span>
                                    <div className="ability-score-manager-stat-total">
                                        Total: {AbilityUtils.getTotalScore(abilityScore) ?? '--'}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
